import {CURRENT_SCHEMA_VERSION} from './quoteTemplateSchema';
import type {QuoteTemplate} from '../resolver/types';

/**
 * The template as stored: what the user authored, merge tokens unresolved.
 *
 * The version written is always the CURRENT one. The in-memory template has already been migrated
 * to it, so writing back whatever version it was loaded at would make the row claim to be older
 * than its contents.
 */
export function serializeTemplate(template: QuoteTemplate): string {
	return JSON.stringify({...template, schemaVersion: CURRENT_SCHEMA_VERSION});
}
